import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { adminApi } from '@/api/tmm/admin';
import { ApiError } from '@/api/errors';
import { useCopy } from '@/hooks/useCopy';
import { AffiliatePage, type AffiliateUpstream } from '../affiliates/AffiliatePage';

export function PartnerAffiliatePage() {
  const { resellerId } = useParams();
  return <PartnerAffiliateContent key={resellerId} id={Number(resellerId)} />;
}
function PartnerAffiliateContent({ id }: { id: number }) {
  const { t } = useCopy();
  const [response, setResponse] = useState<{ slug: string | null; failure: unknown } | null>(null);
  const [token, setToken] = useState(0);
  useEffect(() => {
    let cancelled = false;
    adminApi
      .getReseller(id)
      .then((reseller) => {
        if (!cancelled) setResponse({ slug: reseller.tenant?.slug ?? null, failure: null });
      })
      .catch((failure: unknown) => {
        if (!cancelled) setResponse({ slug: null, failure });
      });
    return () => {
      cancelled = true;
    };
  }, [id, token]);
  // One page for every state of the route (TMM-B7): resolving the partner, its failure and the
  // affiliate itself are the affiliate page's own states, so its `h1` is one element throughout.
  if (response?.slug) return <AffiliatePage tenantSlug={response.slug} />;
  let upstream: AffiliateUpstream = { state: 'pending' };
  if (response) {
    upstream =
      response.failure && !(response.failure instanceof ApiError && response.failure.status === 404)
        ? {
            state: 'failed',
            failure: response.failure,
            message: t('partners.resolveError', 'Could not find this partner.'),
            onRetry: () => setToken((n) => n + 1),
          }
        : { state: 'missing' };
  }
  return <AffiliatePage upstream={upstream} />;
}
